export const ADD_TO_NET_WORTH_KIND = {
  EXCHANGE: 'exchange',
  WALLET: 'wallet',
  BANK: 'bank',
  BROKER: 'broker',
}
